// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CodeEditor__editorWrapper___3IGhI{position:absolute;top:0;background:#fff;z-index:99999;height:100%;width:100%}.CodeEditor__aceEditor___gmMAN{width:100%}.CodeEditor__editorLoader___1ggN2{width:100%;height:100%;position:absolute;z-index:999999;background:rgba(255,255,255,0.8);top:0;left:0}.CodeEditor__editorLoader___1ggN2>div{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.CodeEditor__editorConsoleTab___3Q29_{background:#f3f3f3;border-bottom:1px solid #d0d0d0}.CodeEditor__editorConsoleTab___3Q29_ span{font-size:12px}\n", ""]);
// Exports
exports.locals = {
	"editorWrapper": "CodeEditor__editorWrapper___3IGhI",
	"aceEditor": "CodeEditor__aceEditor___gmMAN",
	"editorLoader": "CodeEditor__editorLoader___1ggN2",
	"editorConsoleTab": "CodeEditor__editorConsoleTab___3Q29_"
};
module.exports = exports;
